module.exports = __webpack_public_path__ + "static/media/banner-bar.a8010a94.png";